<template>
  <div data-testid="transaction-matching-config-new__results-section" class="pt-2 pb-0 pl-0 pr-0">
    <div v-if="(statusCheck === TM_STATUS.FINISHED || statusCheck === TM_STATUS.AI_IN_PROGRESS || statusCheck === TM_STATUS.IN_PROGRESS)">
      <div data-testid="transaction-matching-config-new__two-file-results" class="my-2" v-if="analysisDetails.filecount === TM_RECONCILIATION.FILE_TYPES.TWO_FILE">
        <div data-testid="transaction-matching-config-new__verification-list" v-if="Object.keys(rundetails).length > 1">
          <div v-for="(v, k) in verificationlist" data-testid="transaction-matching-config-new__verification-item" :key="k" :class="`${selectedResultTab === k
            ? 'border-left-primary'
            : 'border-left-transparent'
            }`" :id="'automation-test-'+ k">
            <div data-testid="transaction-matching-config-new__verification-item-content" @click="$emit('update:selectedResultTab', k); $emit('generate-annexure-list', v);" :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedResultTab === k ? 'grey lighten-4' : ''}`">
              <div class="mr-2">
                <v-tooltip bottom content-class="tooltip-bottom" v-if="(rundetails[v._id] || {}).stage === 1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon data-testid="transaction-matching-config-new__verification-status-completed" v-bind="attrs" v-on="on" color="success">mdi-check-circle</v-icon>
                  </template>
                  <span>Completed</span>
                </v-tooltip>
                <v-tooltip bottom content-class="tooltip-bottom" v-else-if="
                  (rundetails[v._id] || {}).stage === 4
                  ">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon data-testid="transaction-matching-config-new__verification-status-running" v-bind="attrs" v-on="on" color="error">mdi-radiobox-marked</v-icon>
                  </template>
                  <span>Currently running</span>
                </v-tooltip>
                <v-tooltip bottom content-class="tooltip-bottom" v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon data-testid="transaction-matching-config-new__verification-status-pending" v-bind="attrs" v-on="on" color="info">mdi-timer-sand</v-icon>
                  </template>
                  <span>Pending</span>
                </v-tooltip>
              </div>
              <div data-testid="transaction-matching-config-new__verification-name">
                {{ v.name }}
              </div>
            </div>
          </div>
        </div>
        <v-tabs data-testid="transaction-matching-config-new__result-tabs" :value="resultTab" @change="$emit('update:resultTab', $event)" color="primary" class="mb-2" v-if="annexurelist.length > 0">
          <v-tab data-testid="transaction-matching-config-new__result-tab" v-for="(item,index) in resultTabItem" :key="index"  @click="$emit('collection-get', item.value, index)" :id="'automation-test-'+index" :disabled="ailoadingimage">
            <v-icon data-testid="transaction-matching-config-new__result-tab-ai-icon" left v-if="index === 3">
              mdi-head-snowflake
            </v-icon>
            <span :class="[item.className, '']">{{ item.name }}</span>
          </v-tab>
          <v-spacer></v-spacer>
          <div data-testid="transaction-matching-config-new__result-actions" class="d-flex align-center ga-2">
            <v-spacer></v-spacer>
            <v-btn data-testid="transaction-matching-config-new__matched-ai-button" color="green--text  lightgreen" class="mr-2 shadow-off " @click="$emit('matched-ai-item', stagefilterAI)" v-if="(stagefilterAI.length > 0 && tabletype === 'AI')">
              <span>Matched</span>
            </v-btn>

            <!-- Download Excel button with split button design for TMResults -->
            <DownloadExcel
              v-if="!loading && tabletype !== 'AI' && tabletype !== 'Consolidated'"
              class="mr-2"
              button-text="Generate Excel"
              test-id-prefix="transaction-matching-config-new__download-excel"
              :download-history="downloadExcelHistory"
              :loading-history="loadingExcelHistory"
              :current-user-id="$store.state.user.id"
              @generate="$emit('generate-result', 'TMResults')"
              @refresh="$emit('fetch-download-history-background')"
              @download="$emit('download-history-file', $event)"
            />
            <v-btn data-testid="transaction-matching-config-new__bulk-manual-matching-consolidated-button" color="primary" class="mr-2 shadow-off" @click="$emit('bulk-manual-matching-consolidated')" v-if="!loading && tabletype === 'Consolidated'">
              <v-icon class="mr-1">mdi-file-upload-outline</v-icon><span>Bulk Manual Matching</span>
            </v-btn>
            <v-btn data-testid="transaction-matching-config-new__bulk-manual-matching-twofile-button" color="primary" class="mr-2 shadow-off" @click="$emit('bulk-manual-matching')" v-if="!loading && tabletype === 'Unmatched'">
              <v-icon class="mr-1">mdi-file-upload-outline</v-icon><span>Bulk Manual Matching</span>
            </v-btn>
            <!-- Download Excel button with split button design for AI -->
            <DownloadExcel
              v-if="!loading && tabletype === 'AI'"
              class="mr-2"
              button-text="Generate Excel"
              test-id-prefix="transaction-matching-config-new__download-excel"
              :download-history="downloadExcelHistory"
              :loading-history="loadingExcelHistory"
              :current-user-id="$store.state.user.id"
              @generate="$emit('generate-result', 'AI')"
              @refresh="$emit('fetch-download-history-background')"
              @download="$emit('download-history-file', $event)"
            />
            
            <v-btn data-testid="transaction-matching-config-new__run-ai-button" color="primary" class="mr-2 shadow-off " @click="$emit('setup-ai', resultTab, tabletype)" v-if="tabletype === 'AI'">
              <v-icon data-testid="transaction-matching-config-new__run-ai-icon" class="mr-1">mdi-memory</v-icon><span>Run AI</span>
            </v-btn>
            <v-btn data-testid="transaction-matching-config-new__ai-in-progress-badge" color="lightblue blue--text" v-if="(statusCheck === TM_STATUS.AI_IN_PROGRESS && tabletype === 'AI')" class="mr-2 shadow-off ">
              <span>AI In Progress</span>
            </v-btn>
            <v-btn data-testid="transaction-matching-config-new__ai-execution-result-button" color="primary" class="mr-2 shadow-off " @click="$emit('start-run-ai-execution', analysisDetails.filecount)" v-if="(tabletype === 'AI' && executionbtnAI)">
              <span>AI Execution Result</span>
            </v-btn>
          </div>
        </v-tabs>
        <v-tabs-items data-testid="transaction-matching-config-new__result-tabs-items" :value="resultTab" @change="$emit('update:resultTab', $event)">
          <v-tab-item data-testid="transaction-matching-config-new__result-tab-item" v-for="(item,index) in resultTabItem" :key="index" class="mb-2">
            <div :id="'automation-test-'+ index">
              <v-row class="ma-0 mt-2">
                <v-col cols="12" class="my-0 pa-0">
                  <div data-testid="transaction-matching-config-new__ai-loading-state" v-if="ailoadingimage">
                    <div class="text-center fade-in-image">
                      <img data-testid="transaction-matching-config-new__loading-image" src="/img/loader_new.svg" />
                    </div>
                  </div>
                  <div v-else>
                    <div data-testid="transaction-matching-config-new__matched-view" v-if="tabletype === 'Matched'">
                      <div data-testid="transaction-matching-config-new__table-one" class="table-one">
                        <div data-testid="transaction-matching-config-new__table-one-header" class="d-flex">
                          <div class="d-flex align-center">
                            <div data-testid="transaction-matching-config-new__table-one-title" class="font-size-md font-weight-medium mr-2"> Table One {{tabletype}}: </div>
                          </div>
                          <v-btn data-testid="transaction-matching-config-new__table-one-clear-filter" color="primary" class="" @click="$emit('clear-filter-two-file', table1twofileglobalInfo, 'table1')" v-if="table1twoglobalList.length > 0">
                            <span>Clear Filter </span>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <div data-testid="transaction-matching-config-new__table-one-pagination" class="radius-on border-on" v-if="table1pagecounttwofile > 1 && !loading && tableOneItemsTwoFile.length > 0">
                            <v-btn data-testid="transaction-matching-config-new__table-one-prev-page" icon :disabled="table1twofile === 1" @click="emitPaginationTable1TwoFile(table1twofile - 1)">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <span data-testid="transaction-matching-config-new__table-one-page-info" class="mx-1">Page {{ table1twofile }} of {{ table1pagecounttwofile }}</span>
                            <v-btn data-testid="transaction-matching-config-new__table-one-next-page" icon :disabled="table1twofile === table1pagecounttwofile" @click="emitPaginationTable1TwoFile(table1twofile + 1)">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <div class="">
                          <v-simple-table data-testid="transaction-matching-config-new__table-one-data" class="border-on" v-if="tableOneItemsTwoFile.length > 0 && !loading" fixed-header :height="tableOneItemsTwoFile.length >= 50 ? '300px' : 'auto'">
                            <template v-slot:default>
                              <thead class="tableHeaderBg">
                                <tr v-if="tabletype === 'Matched'" class="tableHeaderBg">
                                  <th class="ellipsis-on tableHeaderBg" :style="{ 'height': 30 + 'px' }">
                                    <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" dense>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on">
                                          <v-icon>mdi-filter-menu</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list dense class="border-left-default py-0">
                                        <v-list-item class="py-0 px-0 my-0">
                                          <v-list-item-title class="pa-2">
                                            <div class="d-flex align-center">

                                              <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagetable1twofile || []).includes(1)" @change="handleCheckboxUpdate('update:stagetable1twofile', stagetable1twofile, 1, $event)" multiple :value="1"></v-checkbox>
                                              <v-icon class="success--text" left>mdi-check-circle</v-icon>
                                              <span class="success--text">Automated</span>
                                            </div>
                                          </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="py-0 px-0 my-0">
                                          <v-list-item-title class="pa-2">
                                            <div class="d-flex align-center">
                                              <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagetable1twofile || []).includes(0)" @change="handleCheckboxUpdate('update:stagetable1twofile', stagetable1twofile, 0, $event)" multiple :value="0"></v-checkbox>
                                              <v-icon class="info--text" left>mdi-timer-sand</v-icon>
                                              <span class="info--text">Suggested</span>
                                            </div>
                                          </v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </th>
                                  <template v-for="k in tableOneItemtwofileKeys">

                                    <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                      {{ (k || "").replaceAll("_", " ") }}
                                      <v-btn class="grey--text text--lighten-1" icon @click="$emit('table1-global-two-file', k, table1collectiontwofile, 'table1', 'global')">
                                        <v-icon>mdi-filter</v-icon>
                                      </v-btn>
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody v-if="tabletype === 'Matched'">
                                <tr v-for="(v, k) in tableOneItemsTwoFile" :key="k" :id="'automation-test-'+k" class="ellipsis-on">
                                  <td :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                    <div class="d-flex align-center">
                                      <v-icon v-if="v['Match Nature'] === 'Automated'" color="success">mdi-check</v-icon>
                                      <v-icon v-else-if="v['Match Nature'] === 'Suggested'" color="info">mdi-timer-sand</v-icon>
                                      <v-icon v-else-if="v['Match Nature'] === 'Manual'" color="warning">mdi-account-check</v-icon>
                                      <template v-if="v['Match Nature'] === 'Suggested' && v['Verified'] !== 1">
                                        <v-btn icon @click="$emit('move-transaction', v, 'approve', table1collectiontwofile)" color="success">
                                          <v-icon>mdi-check-circle</v-icon>
                                        </v-btn>
                                        <v-btn icon @click="$emit('move-transaction', v, 'reject', table1collectiontwofile)" color="error">
                                          <v-icon>mdi-close-circle</v-icon>
                                        </v-btn>
                                      </template>
                                    </div>
                                  </td>
                                  <template v-for="kk in tableOneItemtwofileKeys">
                                    <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk" :style="{ 'height': 30 + 'px' }">
                                      <span v-if="typeof v[kk] === 'number'">
                                        {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                      </span>
                                      <span v-else>
                                        {{ isValidDate(v[kk]) }}
                                      </span>
                                    </td>
                                  </template>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                          <div data-testid="transaction-matching-config-new__table-one-empty-state" v-else class="text-center grey--text title pa-6"> No data available </div>
                        </div>
                      </div>
                      <div data-testid="transaction-matching-config-new__table-two" class="table-two">
                        <div data-testid="transaction-matching-config-new__table-two-header" class="d-flex">
                          <div class="d-flex align-center">
                            <div data-testid="transaction-matching-config-new__table-two-title" class="font-size-md font-weight-medium mr-2"> Table Two {{tabletype}}: </div>
                          </div>
                          <v-btn data-testid="transaction-matching-config-new__table-two-clear-filter" color="primary" class="" @click="$emit('clear-filter-two-file', table2twofileglobalInfo, 'table2')" v-if="table2twoglobalList.length > 0">
                            <span>Clear Filter </span>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <div data-testid="transaction-matching-config-new__table-two-pagination" class="radius-on border-on" v-if="table2pagecounttwofile > 1 && !loading && tableOneItemsTwoFile.length > 0">
                            <v-btn data-testid="transaction-matching-config-new__table-two-prev-page" icon :disabled="table2twofile === 1" @click="emitPaginationTable2TwoFile(table2twofile - 1)">
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <span data-testid="transaction-matching-config-new__table-two-page-info" class="mx-1">Page {{ table2twofile }} of {{ table2pagecounttwofile }}</span>
                            <v-btn data-testid="transaction-matching-config-new__table-two-next-page" icon :disabled="table2twofile === table2pagecounttwofile" @click="emitPaginationTable2TwoFile(table2twofile + 1)">
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <div class="">
                          <v-simple-table data-testid="transaction-matching-config-new__table-two-data" class="border-on" v-if="tableTwoItemsTwoFile.length > 0 && !loading" fixed-header :height="tableTwoItemsTwoFile.length >= 50 ? '300px' : 'auto'">
                            <template v-slot:default>
                              <thead class="tableHeaderBg">
                                <tr v-if="tabletype === 'Matched'" class="tableHeaderBg">
                                  <th class="ellipsis-on tableHeaderBg" :style="{ 'height': 30 + 'px' }">
                                    <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" dense>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on">
                                          <v-icon>mdi-filter-menu</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list dense class="border-left-default py-0">
                                        <v-list-item class="py-0 px-0 my-0">
                                          <v-list-item-title class="pa-2">
                                            <div class="d-flex align-center">
                                              <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagetable2twofile || []).includes(1)" @change="handleCheckboxUpdate('update:stagetable2twofile', stagetable2twofile, 1, $event)" multiple :value="1"></v-checkbox>
                                              <v-icon class="success--text" left>mdi-check-circle</v-icon>
                                              <span class="success--text">Automated</span>
                                            </div>
                                          </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item class="py-0 px-0 my-0">
                                          <v-list-item-title class="pa-2">
                                            <div class="d-flex align-center">
                                              <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagetable2twofile || []).includes(0)" @change="handleCheckboxUpdate('update:stagetable2twofile', stagetable2twofile, 0, $event)" multiple :value="0"></v-checkbox>
                                              <v-icon class="info--text" left>mdi-timer-sand</v-icon>
                                              <span class="info--text">Suggested</span>
                                            </div>
                                          </v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </th>
                                  <template v-for="k in tableTwoItemtwofileKeys">
                                    <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                      {{ (k || "").replaceAll("_", " ") }}
                                      <v-btn class="grey--text text--lighten-1" icon @click="$emit('table2-global-two-file', k, table2collectiontwofile, 'table2', 'global')">
                                        <v-icon>mdi-filter</v-icon>
                                      </v-btn>
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody v-if="tabletype === 'Matched'">
                                <tr v-for="(v, k) in tableTwoItemsTwoFile" :key="k" :id="'automation-test-'+k" class="ellipsis-on">
                                  <td :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                    <div class="d-flex align-center">
                                      <v-icon v-if="v['Match Nature'] === 'Automated'" color="success">mdi-check</v-icon>
                                      <v-icon v-else-if="v['Match Nature'] === 'Suggested'" color="info">mdi-timer-sand</v-icon>
                                      <v-icon v-else-if="v['Match Nature'] === 'Manual'" color="warning">mdi-account-check</v-icon>
                                      <template v-if="v['Match Nature'] === 'Suggested' && v['Verified'] !== 1">
                                        <v-btn icon @click="$emit('move-transaction', v, 'approve', table2collectiontwofile)" color="success">
                                          <v-icon>mdi-check-circle</v-icon>
                                        </v-btn>
                                        <v-btn icon @click="$emit('move-transaction', v, 'reject', table2collectiontwofile)" color="error">
                                          <v-icon>mdi-close-circle</v-icon>
                                        </v-btn>
                                      </template>
                                    </div>
                                  </td>
                                  <template v-for="kk in tableTwoItemtwofileKeys">
                                    <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk" :style="{ 'height': 30 + 'px' }">
                                      <span v-if="typeof v[kk] === 'number'">
                                        {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                      </span>
                                      <span v-else>
                                        {{ isValidDate(v[kk]) }}
                                      </span>
                                    </td>
                                  </template>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                          <div data-testid="transaction-matching-config-new__table-two-empty-state" v-else class="text-center grey--text title pa-6"> No data available </div>
                        </div>
                      </div>
                    </div>

                    
                    <!-- Unmatched and AI logic similar pattern... I have to implement them all -->
                     <div data-testid="transaction-matching-config-new__unmatched-view" v-else-if="tabletype === 'Unmatched'">
                          <div data-testid="transaction-matching-config-new__unmatched-table-one" class="table-one">
                              <div class="d-flex">
                                  <div class="d-flex align-center">
                                      <div class="font-size-md font-weight-medium mr-2"> Table One {{tabletype}}: </div>
                                  </div>
                                  <v-btn color="primary" class="" @click="$emit('clear-filter-two-file',table1twofileglobalInfo,'table1')" v-if="table1twoglobalList.length > 0">
                                      <span>Clear Filter </span>
                                  </v-btn>
                                  <v-spacer></v-spacer>
                                  <div class="radius-on border-on" v-if="table1pagecounttwofile > 1 && !loading && tableOneItemsTwoFile.length > 0">
                                      <v-btn icon :disabled="table1twofile === 1" @click="emitPaginationTable1TwoFile(table1twofile - 1)">
                                          <v-icon>mdi-chevron-left</v-icon>
                                      </v-btn>
                                      <span class="mx-1">Page {{ table1twofile }} of {{ table1pagecounttwofile }}</span>
                                      <v-btn icon :disabled="table1twofile === table1pagecounttwofile" @click="emitPaginationTable1TwoFile(table1twofile + 1)">
                                          <v-icon>mdi-chevron-right</v-icon>
                                      </v-btn>
                                  </div>
                              </div>
                              <div class="mt-3">
                                  <v-simple-table class="border-on" v-if="tableOneItemsTwoFile.length > 0 && !loading" fixed-header height="300px">
                                      <template v-slot:default>
                                          <thead class="tableHeaderBg">
                                              <tr v-if="tabletype === 'Unmatched'" class="tableHeaderBg">
                                                  <th class="tableHeaderBg" :style="{ 'height': 30 + 'px' }"></th>
                                                  <template v-for="k in tableOneItemtwofileKeys">
                                                      <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                                          {{ (k || "").replaceAll("_", " ") }}
                                                          <v-btn class="grey--text text--lighten-1" icon @click="$emit('table1-global-two-file',k,table1collectiontwofile,'table1','global')">
                                                              <v-icon>mdi-filter</v-icon>
                                                          </v-btn>

                                                      </th>
                                                  </template>
                                              </tr>
                                          </thead>
                                          <tbody v-if="tabletype === 'Unmatched'">
                                              <tr v-for="(v, k) in tableOneItemsTwoFile" :key="k" :id="'automation-test-'+k" class="ellipsis-on">
                                                  <td :id="'automation-test-'+ k" :style="{ 'height': 30 + 'px' }">
                                                      <div class="d-flex align-center">
                                                          <v-btn icon @click="$emit('open-match-dialog',v,table2collectiontwofile,'table1')" color="primary">
                                                              <v-icon>mdi-file-compare</v-icon>
                                                          </v-btn>
                                                      </div>
                                                  </td>
                                                  <template v-for="kk in tableOneItemtwofileKeys">
                                                      <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk" :style="{ 'height': 30 + 'px' }">
                                                          <span v-if="typeof v[kk] === 'number'">
                                                              {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                          </span>
                                                          <span v-else>
                                                              {{isValidDate(v[kk])}}
                                                          </span>
                                                      </td>
                                                  </template>
                                              </tr>
                                          </tbody>
                                      </template>
                                  </v-simple-table>
                                  <div v-else class="text-center grey--text title pa-6"> No data available </div>
                              </div>
                          </div>
                          <div class="table-two">
                              <div class="d-flex">
                                  <div class="d-flex align-center">
                                      <div class="font-size-md font-weight-medium mr-2"> Table Two {{tabletype}}:</div>
                                  </div>
                                  <v-btn color="primary" class="" @click="$emit('clear-filter-two-file',table2twofileglobalInfo,'table2')" v-if="table2twoglobalList.length > 0">
                                      <span>Clear Filter </span>
                                  </v-btn>
                                  <v-spacer></v-spacer>
                                  <div class="radius-on border-on" v-if="table2pagecounttwofile > 1 && !loading && tableOneItemsTwoFile.length > 0">
                                      <v-btn icon :disabled="table2twofile === 1" @click="emitPaginationTable2TwoFile(table2twofile - 1)">
                                          <v-icon>mdi-chevron-left</v-icon>
                                      </v-btn>
                                      <span class="mx-1">Page {{ table2twofile }} of {{ table2pagecounttwofile }}</span>
                                      <v-btn icon :disabled="table2twofile === table2pagecounttwofile" @click="emitPaginationTable2TwoFile(table2twofile + 1)">
                                          <v-icon>mdi-chevron-right</v-icon>
                                      </v-btn>
                                  </div>
                              </div>
                              <div class="mt-3">
                                  <v-simple-table class="border-on" v-if="tableTwoItemsTwoFile.length > 0 && !loading" fixed-header height="300px">
                                      <template v-slot:default>
                                          <thead class="tableHeaderBg">
                                              <tr v-if="tabletype === 'Unmatched'" class="tableHeaderBg">
                                                  <th class="tableHeaderBg" :style="{ 'height': 30 + 'px' }"></th>
                                                  <template v-for="k in tableTwoItemtwofileKeys">
                                                      <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                                          {{ (k || "").replaceAll("_", " ") }}
                                                          <v-btn class="grey--text text--lighten-1" icon @click="$emit('table2-global-two-file',k,table2collectiontwofile,'table1','global')">
                                                              <v-icon>mdi-filter</v-icon>
                                                          </v-btn>
                                                      </th>
                                                  </template>
                                              </tr>
                                          </thead>
                                          <tbody v-if="tabletype === 'Unmatched'">
                                              <tr v-for="(v, k) in tableTwoItemsTwoFile" :key="k" :id="'automation-test-'+k" class="ellipsis-on">
                                                  <td :id="'automation-test-'+ k" :style="{ 'height': 30 + 'px' }">
                                                      <div class="d-flex align-center">
                                                          <v-btn icon @click="$emit('open-match-dialog',v,table1collectiontwofile,'table2')" color="primary">
                                                              <v-icon>mdi-file-compare</v-icon>
                                                          </v-btn>
                                                      </div>
                                                  </td>
                                                  <template v-for="kk in tableTwoItemtwofileKeys">
                                                      <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk" :style="{ 'height': 30 + 'px' }">
                                                          <div v-if="typeof v[kk] === 'number'">
                                                              {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                          </div>
                                                          <div v-else>
                                                              {{isValidDate(v[kk])}}
                                                          </div>
                                                      </td>
                                                  </template>
                                              </tr>
                                          </tbody>
                                      </template>
                                  </v-simple-table>
                                  <div v-else class="text-center grey--text title pa-6"> No data available </div>
                              </div>
                          </div>

                      </div>
                        <div data-testid="transaction-matching-config-new__ai-view" v-else>
                                <div data-testid="transaction-matching-config-new__ai-controls" class="d-flex">
                                <v-btn data-testid="transaction-matching-config-new__ai-clear-filter" color="primary" class="" @click="$emit('clear-filter-all',GlobaleCollection,'TwofileAI')" v-if="table2twoglobalList.length > 0">
                                  <span>Clear Filter </span>
                              </v-btn>
                                <v-spacer></v-spacer>
                                  <div data-testid="transaction-matching-config-new__ai-pagination" class="radius-on border-on mb-2" v-if="pagecount > 1 && !loading && pageItems.length > 0">
                                  <v-btn data-testid="transaction-matching-config-new__ai-prev-page" icon :disabled="page === 1" @click="emitPaginationAI(page - 1)">
                                      <v-icon>mdi-chevron-left</v-icon>
                                  </v-btn>
                                  <span data-testid="transaction-matching-config-new__ai-page-info" class="mx-1">Page {{ page}} of {{ pagecount }}</span>
                                  <v-btn data-testid="transaction-matching-config-new__ai-next-page" icon :disabled="pagenew === pagecount" @click="emitPaginationAI(page + 1)">
                                      <v-icon>mdi-chevron-right</v-icon>
                                  </v-btn>
                                  </div>
                              </div>
                                  <div data-testid="transaction-matching-config-new__ai-table" v-if="pageItems.length > 0">
                                      <!-- Summary Table Component -->
                                      <SummaryTable 
                                          v-if="tabletype === 'Summary'"
                                          :tableData="pageItems"
                                          :itemsPerPage="10"
                                          :searchTerm="''"
                                      />
                                      
                                      <!-- Original v-simple-table for other table types -->
                                      <v-simple-table v-else dense class="border-on" fixed-header :height="pagecount > 1 ? '800px' : ''">
                                          <template v-slot:default>
                                              <thead class="tableHeaderBg">
                                                  <tr v-if="tabletype === 'Summary'" class="tableHeaderBg">
                                                      <template v-for="k in pageItemsKeys">
                                                          <th :key="k" v-if="k !== '_id'" :id="'automation-test-'+k" class="ellipsis-on tableHeaderBg">
                                                              <div v-if="k === 'index'">

                                                              </div>
                                                              <div v-else>
                                                                  {{ (k || "").replaceAll("_", " ") }}
                                                              </div>

                                                          </th>
                                                      </template>
                                                  </tr>
                                                  <tr v-if="tabletype === 'Matched'">
                                                      <th id="table" class="ellipsis-on">
                                                          <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" dense>
                                                              <template v-slot:activator="{ on, attrs }">
                                                                  <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on">
                                                                      <v-icon>mdi-filter-menu</v-icon>
                                                                  </v-btn>
                                                              </template>
                                                              <v-list dense class="border-left-default py-0">
                                                                  <v-list-item class="py-0 px-0 my-0">
                                                                      <v-list-item-title class="pa-2">
                                                                          <div class="d-flex align-center">
                                                                              <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagefilter || []).includes(1)" @change="handleCheckboxUpdate('update:stagefilter', stagefilter, 1, $event)" multiple :value="1"></v-checkbox>
                                                                              <v-icon class="success--text" left>mdi-check-circle</v-icon>
                                                                              <span class="success--text">Automated</span>
                                                                          </div>
                                                                      </v-list-item-title>
                                                                  </v-list-item>
                                                                  <v-list-item class="py-0 px-0 my-0">
                                                                      <v-list-item-title class="pa-2">
                                                                          <div class="d-flex align-center">
                                                                              <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagefilter || []).includes(0)" @change="handleCheckboxUpdate('update:stagefilter', stagefilter, 0, $event)" multiple :value="0"></v-checkbox>
                                                                              <v-icon class="info--text" left>mdi-timer-sand</v-icon>
                                                                              <span class="info--text">Suggested</span>
                                                                          </div>
                                                                      </v-list-item-title>
                                                                  </v-list-item>
                                                              </v-list>
                                                          </v-menu>
                                                      </th>
                                                      <template v-for="k in pageItemsKeys">
                                                          <th class="ellipsis-on" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k">
                                                              {{ (k || "").replaceAll("_", " ") }}
                                                              <v-btn class="grey--text text--lighten-1" icon @click="$emit('global-filter-pop',k,selectedcollection)">
                                                                  <v-icon>mdi-filter</v-icon>
                                                              </v-btn>
                                                          </th>
                                                      </template>
                                                  </tr>
                                                  <tr v-if="tabletype === 'Unmatched'">
                                                      <th></th>
                                                      <template v-for="k in pageItemsKeys">
                                                          <th class="ellipsis-on" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k">
                                                              {{ (k || "").replaceAll("_", " ") }}
                                                              <v-btn class="grey--text text--lighten-1" icon @click="$emit('global-filter-pop',k,selectedcollection)">
                                                                  <v-icon>mdi-filter</v-icon>
                                                              </v-btn>
                                                          </th>
                                                      </template>
                                                  </tr>
                                                  <tr v-if="tabletype === 'AI'">
                                                      <th></th>
                                                      <template v-for="k in pageItemsKeys">
                                                          <th class="ellipsis-on" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k">
                                                              {{ (k || "").replaceAll("_", " ") }}
                                                              <v-btn class="grey--text text--lighten-1" icon @click="$emit('global-filter-pop',k,selectedcollection)">
                                                                  <v-icon>mdi-filter</v-icon>
                                                              </v-btn>
                                                          </th>
                                                      </template>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                      <tr v-for="(v, k) in pageItems" :key="k" :class="((tabletype === 'AI') && (v['Source'] === 'df1')) ? '': ''">
                                                          <td class="" v-if="tabletype === 'Matched'" :id="'automation-test-'+k">
                                                              <div class="d-flex align-center">
                                                                  <v-icon v-if="v['Match Nature'] === 'Automated'" color="success">mdi-check</v-icon>
                                                                  <v-icon v-else-if="v['Match Nature'] === 'Suggested'" color="info">mdi-timer-sand</v-icon>
                                                                  <v-icon v-else-if="v['Match Nature'] === 'Manual'" color="warning">mdi-account-check</v-icon>
                                                                  <template v-if="v['Match Nature'] === 'Suggested' && v['Verified'] !== 1">
                                                                      <v-btn icon @click="$emit('move-transaction',v, 'approve')" color="success">
                                                                          <v-icon>mdi-check-circle</v-icon>
                                                                      </v-btn>
                                                                      <v-btn icon @click="$emit('move-transaction',v, 'reject')" color="error">
                                                                          <v-icon>mdi-close-circle</v-icon>
                                                                      </v-btn>
                                                                  </template>
                                                              </div>
                                                          </td>
                                                          <td v-if="tabletype === 'Unmatched'" :id="'automation-test-'+k">
                                                              <div class="d-flex align-center">
                                                                  <v-btn icon @click="$emit('open-match-dialog',v,tabletype)" color="primary" class="">
                                                                      <v-icon>mdi-file-compare</v-icon>
                                                                  </v-btn>
                                                              </div>
                                                          </td>
                                                          <td v-if="tabletype === 'AI'" :id="'automation-test-'+k">
                                                              <div class="d-flex align-center" v-if="v['Source'] !== null">
                                                                  <v-checkbox :id="'automation-test-'+ k" multiple :value="v" hide-details dense :input-value="(stagefilterAI || []).includes(v)" @change="handleCheckboxUpdate('update:stagefilterAI', stagefilterAI, v, $event)" class="ma-0 pa-0"></v-checkbox>
                                                              </div>
                                                          </td>
                                                          <template v-for="kk in pageItemsKeys">
                                                              <td :key="kk" v-if="(kk !== '_id')" :id="'automation-test-'+kk">
                                                                  <div v-if="kk === 'index'">
                                                                  </div>
                                                                  <span v-else>
                                                                      <span v-if="typeof v[kk] === 'number'">
                                                                          {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                                      </span>
                                                                      <span v-else>
                                                                          {{isValidDate(v[kk])}}
                                                                      </span>
                                                                    </span>

                                                              </td>
                                                          </template>
                                                      </tr>
                                              </tbody>
                                          </template>
                                      </v-simple-table>
                                  </div>
                                  <div data-testid="transaction-matching-config-new__ai-empty-state" v-else class="text-center grey--text title pa-6"> No data available </div>
                              </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <!-- One file is VERY large. I will implement the rest in next request if it's too long, but checking tokens... I have room -->
      <div data-testid="transaction-matching-config-new__one-file-results" v-else>
          <v-row class="ma-0 d-flex align-center justify-space-between">
        <!-- Tabs -->
        <v-col cols="5" class="d-flex align-center">
          <v-tabs :value="resultTab" @change="$emit('update:resultTab', $event)" class="mb-2" v-if="comboAnnexer.length > 0">
            <!-- Summary Tab - Always present -->
            <v-tab @click="$emit('combo-collection-get', 'Summary', 0)" id="automation-test-0" :disabled="ailoadingimage">
              Summary
            </v-tab>
            
            <!-- Consolidated Tab - Only if consolidated annexure exists -->
            <v-tab v-if="hasConsolidatedAnnexure" @click="$emit('combo-collection-get', 'Consolidated', 1)" id="automation-test-1" :disabled="ailoadingimage">
              Consolidated Annexure
            </v-tab>
            
            <!-- Matched Tab - Only if NO consolidated annexure -->
            <v-tab v-if="!hasConsolidatedAnnexure" @click="$emit('combo-collection-get', 'Matched', 1)" id="automation-test-1" :disabled="ailoadingimage">
              Matched
            </v-tab>
            
            <!-- Unmatched Tab - Only if NO consolidated annexure -->
            <v-tab v-if="!hasConsolidatedAnnexure" @click="$emit('combo-collection-get', 'Unmatched', 2)" id="automation-test-2" :disabled="ailoadingimage">
              Unmatched
            </v-tab>
            
            <!-- AI Tab - Always show -->
            <v-tab @click="$emit('combo-collection-get', 'AI', hasConsolidatedAnnexure ? 2 : 3)" :id="'automation-test-' + (hasConsolidatedAnnexure ? 2 : 3)" :disabled="ailoadingimage">
              AI
            </v-tab>
          </v-tabs>
        </v-col>
        <!-- Dropdown -->
        <v-col cols="3" class="d-flex align-center justify-center">
          <div v-if="resultTab === 0 && summeryCombo.length > 0">
            <lb-dropdown hidedetails label="Summary Filter" :items="summeryCombo" :value="selectedSummeryFilter" @change="$emit('update:selectedSummeryFilter', $event)" itemtext="combo-code" itemvalue="combo-code" />
          </div>
          <div v-else-if="annexercomboKeys.length > 0 && tabletype !== 'Consolidated'">
            <lb-dropdown hidedetails label="Filter" :items="annexercomboKeys" :value="filterCombo" @change="$emit('update:filterCombo', $event)" itemtext="comboCode" itemvalue="comboCode" />
          </div>
        </v-col>
        <!-- Buttons -->
        <v-col cols="4" class="d-flex flex-row-reverse ga-2">
          
          <v-btn color="primary" class="shadow-off " @click="$emit('bulk-manual-matching-one-file')" v-if="!loading && tabletype === 'Unmatched'">
            <v-icon class="">mdi-file-upload-outline</v-icon><span>Bulk Manual Matching</span>
          </v-btn>
          <v-btn color="primary" class="shadow-off " @click="$emit('setup-ai', resultTab, tabletype)" v-if="tabletype === 'AI'">
            <v-icon class="">mdi-memory</v-icon><span>Run AI</span>
          </v-btn>
          
          
          <!-- TMResults: Download Excel split button with dropdown -->
          <DownloadExcel
            v-if="tabletype !== 'AI' && tabletype !== 'Consolidated'"
            button-text="Generate Excel"
            test-id-prefix="transaction-matching-config-new__download-excel-onefile"
            :download-history="downloadExcelHistory"
            :loading-history="loadingExcelHistory"
            :current-user-id="$store.state.user.id"
            @generate="$emit('generate-result', 'TMResults')"
            @refresh="$emit('fetch-download-history-background')"
            @download="$emit('download-history-file', $event)"
          />

          
          <!-- Consolidated: Download Excel split button with dropdown -->
          <DownloadExcel
            v-if="tabletype === 'Consolidated'"
            button-text="Generate Excel"
            test-id-prefix="transaction-matching-config-new__download-consolidated-excel"
            :download-history="downloadExcelHistory"
            :loading-history="loadingExcelHistory"
            :current-user-id="$store.state.user.id"
            @generate="handleConsolidatedGenerate"
            @refresh="$emit('fetch-download-history-background')"
            @download="$emit('download-history-file', $event)"
          />

          
          <!-- AI: Download Excel split button with dropdown -->
          <DownloadExcel
            v-if="tabletype === 'AI'"
            button-text="Generate Excel"
            test-id-prefix="transaction-matching-config-new__download-ai-excel-onefile"
            :download-history="downloadExcelHistory"
            :loading-history="loadingExcelHistory"
            :current-user-id="$store.state.user.id"
            @generate="$emit('generate-result', 'AI')"
            @refresh="$emit('fetch-download-history-background')"
            @download="$emit('download-history-file', $event)"
          />

          <v-btn color="info" v-if="statusCheck === TM_STATUS.AI_IN_PROGRESS && tabletype === 'AI'" class="mr-2 shadow-off "><span>AI In Progress</span></v-btn>
        </v-col>
      </v-row>
          
          <!-- NON-CONSOLIDATED CASE: Render content directly based on tabletype (no v-tabs-items) -->
          <div v-if="!hasConsolidatedAnnexure">
              <div>
                      <v-row class="ma-0">
                          <v-col cols="12" class="my-0 py-0">
                              <div class="d-flex">
                                  <div v-if="filterArray.length >0" class="ml-2 mb-2 grey--text caption">{{filterArray.length}} Filter Applyed
                                      <v-btn color="primary" class="ml-2 " @click="$emit('remove-global-filter', selectcollection, selectkey)">
                                          <v-icon class="mr-1">mdi-filter-remove-outline</v-icon>
                                          <span>Clear all filters</span>
                                      </v-btn>
                                  </div>
                                  <v-spacer></v-spacer>
                                  
                                  
                                  <div class="radius-on border-on mb-2" v-if="pagecountnew > 1 && !loading && pageItemsNew.length > 0">
                                      <v-btn icon :disabled="pagenew === 1" @click="emitPaginationSingle(pagenew - 1)">
                                          <v-icon>mdi-chevron-left</v-icon>
                                      </v-btn>
                                      <span class="mx-1">Page {{ pagenew }} of {{ pagecountnew }}</span>
                                      <v-btn icon :disabled="pagenew === pagecountnew" @click="emitPaginationSingle(pagenew + 1)">
                                          <v-icon>mdi-chevron-right</v-icon>
                                      </v-btn>
                                  </div>
                              </div>
                              <div v-if="ailoadingimage">
                                  <div class="text-center fade-in-image">
                                      <img src="/img/loader_new.svg" />
                                  </div>
                              </div>
                              <div v-else>
                                  <div v-if="tabletype === 'Matched'">
                                      <div class="table-one">
                                          <div class="d-flex">
                                              <div class="d-flex align-center">
                                                  <div class="font-size-md font-weight-medium mr-2"> Table One {{tabletype}}: </div>
                                              </div>
                                              <v-btn color="primary" class=" ml-2" @click="$emit('clear-filter', table1globalInfo, 'table1')" v-if="table1globalList.length > 0">
                                                  <span>Clear Filter </span>
                                              </v-btn>
                                              <v-spacer></v-spacer>

                                              <div class="radius-on border-on" v-if="table1pagecount > 1 && !loading && tableOneItem.length > 0">
                                                  <v-btn icon :disabled="table1 === 1" @click="emitPaginationTable1(table1 - 1)">
                                                      <v-icon>mdi-chevron-left</v-icon>
                                                  </v-btn>
                                                  <span class="mx-1">Page {{ table1 }} of {{ table1pagecount }}</span>
                                                  <v-btn icon :disabled="table1 === table1pagecount" @click="emitPaginationTable1(table1 + 1)">
                                                      <v-icon>mdi-chevron-right</v-icon>
                                                  </v-btn>
                                              </div>
                                          </div>
                                          <div class="mt-3">
                                              <v-simple-table class="border-on" v-if="tableOneItem.length > 0 && !loading" fixed-header :height="tableOneItem.length >= 50 ? '300px' : 'auto'">
                                                  <template v-slot:default>
                                                      <thead class="tableHeaderBg">
                                                          <tr v-if="tabletype === 'Matched'">
                                                              <th class="ellipsis-on tableHeaderBg" :style="{ 'height': 30 + 'px' }">
                                                                  <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" dense>
                                                                      <template v-slot:activator="{ on, attrs }">
                                                                          <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on">
                                                                              <v-icon>mdi-filter-menu</v-icon>
                                                                          </v-btn>
                                                                      </template>
                                                                      <v-list dense class="border-left-default py-0">
                                                                          <v-list-item class="py-0 px-0 my-0">
                                                                              <v-list-item-title class="pa-2">
                                                                                  <div class="d-flex align-center">

                                                                                      <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagefiltertable1 || []).includes(1)" @change="handleCheckboxUpdate('update:stagefiltertable1', stagefiltertable1, 1, $event)" multiple :value="1"></v-checkbox>
                                                                                      <v-icon class="success--text" left>mdi-check-circle</v-icon>
                                                                                      <span class="success--text">Automated</span>
                                                                                  </div>
                                                                              </v-list-item-title>
                                                                          </v-list-item>
                                                                          <v-list-item class="py-0 px-0 my-0">
                                                                              <v-list-item-title class="pa-2">
                                                                                  <div class="d-flex align-center">
                                                                                      <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagefiltertable1 || []).includes(0)" @change="handleCheckboxUpdate('update:stagefiltertable1', stagefiltertable1, 0, $event)" multiple :value="0"></v-checkbox>
                                                                                      <v-icon class="info--text" left>mdi-timer-sand</v-icon>
                                                                                      <span class="info--text">Suggested</span>
                                                                                  </div>
                                                                              </v-list-item-title>
                                                                          </v-list-item>
                                                                      </v-list>
                                                                  </v-menu>
                                                              </th>
                                                              <template v-for="k in tableOneItemKeys">
                                                                  <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                                                      {{ (k || "").replaceAll("_", " ") }}
                                                                      <v-btn class="grey--text text--lighten-1" icon @click="$emit('table1-global',k,table1collection,'table1','global')">
                                                                          <v-icon>mdi-filter</v-icon>
                                                                      </v-btn>
                                                                  </th>
                                                              </template>
                                                          </tr>
                                                      </thead>
                                                      <tbody v-if="tabletype === 'Matched'">
                                                          <tr v-for="(v, k) in tableOneItem" :key="k" :id="'automation-test-'+k" class="ellipsis-on">
                                                              <td :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                                                  <div class="d-flex align-center">
                                                                      <v-icon v-if="v['Match Nature'] === 'Automated'" color="success">mdi-check</v-icon>
                                                                      <v-icon v-else-if="v['Match Nature'] === 'Suggested'" color="info">mdi-timer-sand</v-icon>
                                                                      <v-icon v-else-if="v['Match Nature'] === 'Manual'" color="warning">mdi-account-check</v-icon>
                                                                      <template v-if="v['Match Nature'] === 'Suggested' && v['Verified'] !== 1">
                                                                          <v-btn icon @click="$emit('move-transaction-new',v, 'approve',table1collection)" color="success">
                                                                              <v-icon>mdi-check-circle</v-icon>
                                                                          </v-btn>
                                                                          <v-btn icon @click="$emit('move-transaction-new',v, 'reject',table1collection)" color="error">
                                                                              <v-icon>mdi-close-circle</v-icon>
                                                                          </v-btn>
                                                                      </template>
                                                                  </div>
                                                              </td>
                                                              <template v-for="kk in tableOneItemKeys">
                                                                  <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk" :style="{ 'height': 30 + 'px' }">
                                                                      <span v-if="typeof v[kk] === 'number'">
                                                                          {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                                      </span>
                                                                      <span v-else>
                                                                          {{isValidDate(v[kk])}}
                                                                      </span>

                                                                      <!-- {{ typeof v[kk] === "number" ? $nova.formatNumber(v[kk].toFixed(0)) : v[kk] }} -->
                                                                  </td>
                                                              </template>
                                                          </tr>
                                                      </tbody>
                                                  </template>
                                              </v-simple-table>
                                              <div v-else class="text-center grey--text title pa-6"> No data available </div>
                                          </div>
                                      </div>
                                      <div class="table-two">
                                          <div class="d-flex">
                                              <div class="d-flex align-center">
                                                  <div class="font-size-md font-weight-medium mr-2"> Table Two {{tabletype}}: </div>
                                              </div>
                                              <v-btn color="primary" class="" @click="$emit('clear-filter',table2globalInfo,'table2')" v-if="table2globalList.length > 0">
                                                  <span>Clear Filter </span>
                                              </v-btn>
                                              <v-spacer></v-spacer>
                                              <div class="radius-on border-on" v-if="table2pagecount > 1 && !loading && tableTwoItem.length > 0">
                                                  <v-btn icon :disabled="table2 === 1" @click="emitPaginationTable2(table2 - 1)">
                                                      <v-icon>mdi-chevron-left</v-icon>
                                                  </v-btn>
                                                  <span class="mx-1">Page {{ table2 }} of {{ table2pagecount }}</span>
                                                  <v-btn icon :disabled="table2 === table2pagecount" @click="emitPaginationTable2(table2 + 1)">
                                                      <v-icon>mdi-chevron-right</v-icon>
                                                  </v-btn>
                                              </div>
                                          </div>
                                          <div class="mt-3">
                                              <v-simple-table class="border-on" v-if="tableTwoItem.length > 0 && !loading" fixed-header :height="tableTwoItem.length >= 50 ? '300px' : 'auto'">
                                                  <template v-slot:default>
                                                      <thead class="tableHeaderBg">
                                                          <tr v-if="tabletype === 'Matched'">
                                                              <th class="ellipsis-on tableHeaderBg" :style="{ 'height': 30 + 'px' }">
                                                                  <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" dense>
                                                                      <template v-slot:activator="{ on, attrs }">
                                                                          <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on">
                                                                              <v-icon>mdi-filter-menu</v-icon>
                                                                          </v-btn>
                                                                      </template>
                                                                      <v-list dense class="border-left-default py-0">
                                                                          <v-list-item class="py-0 px-0 my-0">
                                                                              <v-list-item-title class="pa-2">
                                                                                  <div class="d-flex align-center">
                                                                                      <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagefiltertable2 || []).includes(1)" @change="handleCheckboxUpdate('update:stagefiltertable2', stagefiltertable2, 1, $event)" multiple :value="1"></v-checkbox>
                                                                                      <v-icon class="success--text" left>mdi-check-circle</v-icon>
                                                                                      <span class="success--text">Automated</span>
                                                                                  </div>
                                                                              </v-list-item-title>
                                                                          </v-list-item>
                                                                          <v-list-item class="py-0 px-0 my-0">
                                                                              <v-list-item-title class="pa-2">
                                                                                  <div class="d-flex align-center">
                                                                                      <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagefiltertable2 || []).includes(0)" @change="handleCheckboxUpdate('update:stagefiltertable2', stagefiltertable2, 0, $event)" multiple :value="0"></v-checkbox>
                                                                                      <v-icon class="info--text" left>mdi-timer-sand</v-icon>
                                                                                      <span class="info--text">Suggested</span>
                                                                                  </div>
                                                                              </v-list-item-title>
                                                                          </v-list-item>
                                                                      </v-list>
                                                                  </v-menu>
                                                              </th>
                                                              <template v-for="k in tableTwoItemKeys">
                                                                  <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                                                      {{ (k || "").replaceAll("_", " ") }}
                                                                      <v-btn class="grey--text text--lighten-1" icon @click="$emit('table2-global',k,table2collection,'table2','global')">
                                                                          <v-icon>mdi-filter</v-icon>
                                                                      </v-btn>
                                                                  </th>
                                                              </template>
                                                          </tr>
                                                      </thead>
                                                      <tbody v-if="tabletype === 'Matched'">
                                                          <tr v-for="(v, k) in tableTwoItem" :key="k" :id="'automation-test-'+k" class="ellipsis-on">
                                                              <td :id="'automation-test-'+k" :style="{ 'height': 30 + 'px' }">
                                                                  <div class="d-flex align-center">
                                                                      <v-icon v-if="v['Match Nature'] === 'Automated'" color="success">mdi-check</v-icon>
                                                                      <v-icon v-else-if="v['Match Nature'] === 'Suggested'" color="info">mdi-timer-sand</v-icon>
                                                                      <v-icon v-else-if="v['Match Nature'] === 'Manual'" color="warning">mdi-account-check</v-icon>
                                                                      <template v-if="v['Match Nature'] === 'Suggested' && v['Verified'] !== 1">
                                                                          <v-btn icon @click="$emit('move-transaction-new',v, 'approve',table2collection)" color="success">
                                                                              <v-icon>mdi-check-circle</v-icon>
                                                                          </v-btn>
                                                                          <v-btn icon @click="$emit('move-transaction-new',v, 'reject',table2collection)" color="error">
                                                                              <v-icon>mdi-close-circle</v-icon>
                                                                          </v-btn>
                                                                      </template>
                                                                  </div>
                                                              </td>
                                                              <template v-for="kk in tableTwoItemKeys">
                                                                  <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk" :style="{ 'height': 30 + 'px' }">
                                                                      <span v-if="typeof v[kk] === 'number'">
                                                                          {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                                      </span>
                                                                      <span v-else>
                                                                          {{isValidDate(v[kk])}}
                                                                      </span>
                                                                      <!-- {{ typeof v[kk] === "number" ? $nova.formatNumber(v[kk].toFixed(0)) : v[kk] }} -->
                                                                  </td>
                                                              </template>
                                                          </tr>
                                                      </tbody>
                                                  </template>
                                              </v-simple-table>
                                              <div v-else class="text-center grey--text title pa-6"> No data available </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div v-else>
                                      <!-- OnefileSummary Component for Summary table type -->
                                      <OnefileSummary 
                                          v-if="tabletype === 'Summary' && pageItemsNew.length > 0 && !loading"
                                          :tableData="pageItemsNew"
                                          :itemsPerPage="10"
                                          :searchTerm="''"
                                      />
                                      
                                      <!-- Original v-simple-table for other table types -->
                                      <v-simple-table 
                                          v-else-if="pageItemsNew.length > 0 && !loading" 
                                          class="border-on" 
                                          fixed-header 
                                          :height="pagecountnew > 1 ? '500px' : '600px'"
                                      >
                                          <template v-slot:default>
                                              <thead class="tableHeaderBg">
                                                  <tr v-if="tabletype === 'Summary'">
                                                      <template v-for="(v, k) in pageItemsNew[0]">
                                                          <th :key="k" v-if="k !== '_id'" :id="'automation-test-'+k" class="ellipsis-on tableHeaderBg" :style="{ 'height': 30 + 'px' }">
                                                              <div v-if="k === 'index'"></div>
                                                              <div v-else>
                                                                  {{ (k || "").replaceAll("_", " ") }}
                                                              </div>
                                                          </th>
                                                      </template>
                                                  </tr>
                                                  <tr v-if="tabletype === 'Matched'">
                                                      <th id="table" class="ellipsis-on tableHeaderBg">
                                                          <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" dense>
                                                              <template v-slot:activator="{ on, attrs }">
                                                                  <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on">
                                                                      <v-icon>mdi-filter-menu</v-icon>
                                                                  </v-btn>
                                                              </template>
                                                              <v-list dense class="border-left-default py-0">
                                                                  <v-list-item class="py-0 px-0 my-0">
                                                                      <v-list-item-title class="pa-2">
                                                                          <div class="d-flex align-center">
                                                                              <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagefilterNew || []).includes(1)" @change="handleCheckboxUpdate('update:stagefilterNew', stagefilterNew, 1, $event)" multiple :value="1"></v-checkbox>
                                                                              <v-icon class="success--text" left>mdi-check-circle</v-icon>
                                                                              <span class="success--text">Automated</span>
                                                                          </div>
                                                                      </v-list-item-title>
                                                                  </v-list-item>
                                                                  <v-list-item class="py-0 px-0 my-0">
                                                                      <v-list-item-title class="pa-2">
                                                                          <div class="d-flex align-center">
                                                                              <v-checkbox label="" class="mt-0 pt-0" color="grey darken-2" dense hide-details :input-value="(stagefilterNew || []).includes(0)" @change="handleCheckboxUpdate('update:stagefilterNew', stagefilterNew, 0, $event)" multiple :value="0"></v-checkbox>
                                                                              <v-icon class="info--text" left>mdi-timer-sand</v-icon>
                                                                              <span class="info--text">Suggested</span>
                                                                          </div>
                                                                      </v-list-item-title>
                                                                  </v-list-item>
                                                              </v-list>
                                                          </v-menu>
                                                      </th>
                                                      <template v-for="(v, k) in pageItemsNew[0]">
                                                          <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k">
                                                              {{ (k || "").replaceAll("_", " ") }}
                                                              <v-btn class="grey--text text--lighten-1" icon @click="$emit('global-filter-pop-new',k)">
                                                                  <v-icon>mdi-filter</v-icon>
                                                              </v-btn>
                                                          </th>
                                                      </template>
                                                  </tr>
                                                  <tr v-if="tabletype === 'Unmatched'">
                                                      <th class="tableHeaderBg"></th>
                                                      <template v-for="(v, k) in pageItemsNew[0]">
                                                          <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k">
                                                              {{ (k || "").replaceAll("_", " ") }}
                                                              <v-btn class="grey--text text--lighten-1" icon @click="$emit('global-filter-pop-new',k)">
                                                                  <v-icon>mdi-filter</v-icon>
                                                              </v-btn>
                                                          </th>
                                                      </template>
                                                  </tr>
                                                  <tr v-if="tabletype === 'AI'">
                                                      <th class="tableHeaderBg"></th>
                                                      <template v-for="(v, k) in pageItemsNew[0]">
                                                          <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k">
                                                              {{ (k || "").replaceAll("_", " ") }}
                                                              <v-btn class="grey--text text--lighten-1" icon @click="$emit('global-filter-pop-new',k,selectedcollection)">
                                                                  <v-icon>mdi-filter</v-icon>
                                                              </v-btn>
                                                          </th>
                                                      </template>
                                                  </tr>
                                              </thead>
                                              <tbody v-if="tabletype === 'Summary'">
                                                  <tr v-for="(v, k) in pageItemsNew" :key="k" :id="'automation-test-'+k">
                                                      <template v-for="(vv, kk) in pageItemsNew[0]">
                                                          <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+k" :style="{ 'height': 35 + 'px' }">
                                                              <div v-if="kk === 'index'"></div>
                                                              <div v-else>
                                                                  <span v-if="typeof v[kk] === 'number'">
                                                                      {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                                  </span>
                                                                  <span v-else>
                                                                      {{isValidDate(v[kk])}}
                                                                  </span>
                                                              </div>
                                                          </td>
                                                      </template>
                                                  </tr>
                                              </tbody>
                                              <tbody v-if="tabletype === 'Matched'">
                                                  <tr v-for="(v, k) in pageItemsNew" :key="k" :id="'automation-test-'+k">
                                                      <td :id="'automation-test-'+k">
                                                          <div class="d-flex align-center">
                                                              <v-icon v-if="v['Match Nature'] === 'Automated'" color="success">mdi-check</v-icon>
                                                              <v-icon v-else-if="v['Match Nature'] === 'Suggested'" color="info">mdi-timer-sand</v-icon>
                                                              <v-icon v-else-if="v['Match Nature'] === 'Manual'" color="warning">mdi-account-check</v-icon>
                                                              <template v-if="v['Match Nature'] === 'Suggested' && v['Verified'] !== 1">
                                                                  <v-btn icon @click="$emit('move-transaction-new',v, 'approve')" color="success">
                                                                      <v-icon>mdi-check-circle</v-icon>
                                                                  </v-btn>
                                                                  <v-btn icon @click="$emit('move-transaction-new',v, 'reject')" color="error">
                                                                      <v-icon>mdi-close-circle</v-icon>
                                                                  </v-btn>
                                                              </template>
                                                          </div>
                                                      </td>
                                                      <template v-for="(vv, kk) in pageItemsNew[0]">
                                                          <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+kk">
                                                              <span v-if="typeof v[kk] === 'number'">
                                                                  {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                              </span>
                                                              <span v-else>
                                                                  {{isValidDate(v[kk])}}
                                                              </span>
                                                          </td>
                                                      </template>
                                                  </tr>
                                              </tbody>
                                              <tbody v-if="tabletype === 'Unmatched'">
                                                  <tr v-for="(v, k) in pageItemsNew" :key="k" :id="'automation-test-'+k">
                                                      <td :id="'automation-test-'+ k">
                                                          <div class="d-flex align-center">
                                                              <v-btn icon @click="$emit('open-match-dialog-new',v)" color="primary">
                                                                  <v-icon>mdi-file-compare</v-icon>
                                                              </v-btn>
                                                          </div>
                                                      </td>
                                                      <template v-for="(vv, kk) in pageItemsNew[0]">
                                                          <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk">
                                                              <span v-if="typeof v[kk] === 'number'">
                                                                  {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                              </span>
                                                              <span v-else>
                                                                  {{isValidDate(v[kk])}}
                                                              </span>
                                                          </td>
                                                      </template>
                                                  </tr>
                                              </tbody>
                                              <tbody v-if="tabletype === 'AI'">
                                                  <tr v-for="(v, k) in pageItemsNew" :key="k" :id="'automation-test-'+k" :class="((tabletype === 'AI') && (v['Source'] === 'df1')) ? 'light-blue lighten-5': ''">
                                                      <td :id="'automation-test-'+ k">
                                                          <div class="d-flex align-center">
                                                              <v-btn icon @click="$emit('open-match-dialog-new',v)" color="primary" class="">
                                                                  <v-icon>mdi-file-compare</v-icon>
                                                              </v-btn>
                                                          </div>
                                                      </td>
                                                      <template v-for="(vv, kk) in pageItemsNew[0]">
                                                          <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk">
                                                              <span v-if="typeof v[kk] === 'number'">
                                                                  {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                              </span>
                                                              <span v-else>
                                                                  {{isValidDate(v[kk])}}
                                                              </span>
                                                          </td>
                                                      </template>
                                                  </tr>
                                              </tbody>
                                          </template>
                                      </v-simple-table>
                                      <div v-else class="text-center grey--text title pa-6"> No data available </div>
                                  </div>
                              </div>
                          </v-col>
                      </v-row>
                  </div>
          </div>
          
          <!-- CONSOLIDATED CASE: Use v-tabs-items for Summary, Consolidated, and AI -->
          <v-tabs-items :value="resultTab" @change="$emit('update:resultTab', $event)" v-else>
              <!-- Summary Tab Item for Consolidated Case -->
              <v-tab-item>
                  <div>
                      <v-row class="ma-0">
                          <v-col cols="12" class="my-0 py-0">
                              <div class="d-flex">
                                  <div v-if="filterArray.length >0" class="ml-2 mb-2 grey--text caption">{{filterArray.length}} Filter Applyed
                                      <v-btn color="primary" class="ml-2 " @click="$emit('remove-global-filter', selectcollection, selectkey)">
                                          <v-icon class="mr-1">mdi-filter-remove-outline</v-icon>
                                          <span>Clear all filters</span>
                                      </v-btn>
                                  </div>
                                  <v-spacer></v-spacer>
                                 
                                  <div class="radius-on border-on mb-2" v-if="pagecountnew > 1 && !loading && pageItemsNew.length > 0">
                                      <v-btn icon :disabled="pagenew === 1" @click="emitPaginationSingle(pagenew - 1)">
                                          <v-icon>mdi-chevron-left</v-icon>
                                      </v-btn>
                                      <span class="mx-1">Page {{ pagenew }} of {{ pagecountnew }}</span>
                                      <v-btn icon :disabled="pagenew === pagecountnew" @click="emitPaginationSingle(pagenew + 1)">
                                          <v-icon>mdi-chevron-right</v-icon>
                                      </v-btn>
                                  </div>
                              </div>
                              <div v-if="ailoadingimage">
                                  <div class="text-center fade-in-image">
                                      <img src="/img/loader_new.svg" />
                                  </div>
                              </div>
                              <div v-else>
                                  <!-- OnefileSummary Component for Summary table type -->
                                  <OnefileSummary 
                                      v-if="tabletype === 'Summary' && pageItemsNew.length > 0 && !loading"
                                      :tableData="pageItemsNew"
                                      :itemsPerPage="10"
                                      :searchTerm="''"
                                  />
                                  <div v-else-if="pageItemsNew.length === 0" class="text-center grey--text title pa-6"> No data available </div>
                              </div>
                          </v-col>
                      </v-row>
                  </div>
              </v-tab-item>
              
              <!-- Consolidated Tab Item -->
              <v-tab-item>
                  <TMResultsDataTable
                      v-if="resultTab === 1"
                      ref="consolidatedResultsComponent"
                      variant="v1"
                      :analysis-details="analysisDetails"
                      :annexure-list="comboAnnexer"
                      :verification-id="verificationlist[0]?._id || ''"
                      :run-details="rundetails[verificationlist[0]?._id] || {}"
                      :file-config-info="fileConfigInfo"
                      @download-excel="$emit('download-consolidated-excel', $event)"
                      @refresh-data="$emit('refresh-data')"
                  />
              </v-tab-item>
              
              <!-- AI Tab Item for Consolidated Case -->
              <v-tab-item>
                  <div>
                      <v-row class="ma-0">
                          <v-col cols="12" class="my-0 py-0">
                              <div class="d-flex">
                                  <div v-if="filterArray.length >0" class="ml-2 mb-2 grey--text caption">{{filterArray.length}} Filter Applyed
                                      <v-btn color="primary" class="ml-2 " @click="$emit('remove-global-filter', selectcollection, selectkey)">
                                          <v-icon class="mr-1">mdi-filter-remove-outline</v-icon>
                                          <span>Clear all filters</span>
                                      </v-btn>
                                  </div>
                                  <v-spacer></v-spacer>
                                 
                                  <div class="radius-on border-on mb-2" v-if="pagecountnew > 1 && !loading && pageItemsNew.length > 0">
                                      <v-btn icon :disabled="pagenew === 1" @click="emitPaginationSingle(pagenew - 1)">
                                          <v-icon>mdi-chevron-left</v-icon>
                                      </v-btn>
                                      <span class="mx-1">Page {{ pagenew }} of {{ pagecountnew }}</span>
                                      <v-btn icon :disabled="pagenew === pagecountnew" @click="emitPaginationSingle(pagenew + 1)">
                                          <v-icon>mdi-chevron-right</v-icon>
                                      </v-btn>
                                  </div>
                              </div>
                              <div v-if="ailoadingimage">
                                  <div class="text-center fade-in-image">
                                      <img src="/img/loader_new.svg" />
                                  </div>
                              </div>
                              <div v-else>
                                  <v-simple-table 
                                      v-if="pageItemsNew.length > 0 && !loading && tabletype === 'AI'" 
                                      class="border-on" 
                                      fixed-header 
                                      :height="pagecountnew > 1 ? '500px' : '600px'"
                                  >
                                      <template v-slot:default>
                                          <thead class="tableHeaderBg">
                                              <tr>
                                                  <th class="tableHeaderBg"></th>
                                                  <template v-for="(v, k) in pageItemsNew[0]">
                                                      <th class="ellipsis-on tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k">
                                                          {{ (k || "").replaceAll("_", " ") }}
                                                          <v-btn class="grey--text text--lighten-1" icon @click="$emit('global-filter-pop-new', k, selectedcollection)">
                                                              <v-icon>mdi-filter</v-icon>
                                                          </v-btn>
                                                      </th>
                                                  </template>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr v-for="(v, k) in pageItemsNew" :key="k" :id="'automation-test-'+k" :class="(v['Source'] === 'df1') ? 'light-blue lighten-5': ''">
                                                  <td :id="'automation-test-'+ k">
                                                      <div class="d-flex align-center">
                                                          <v-btn icon @click="$emit('open-match-dialog-new', v)" color="primary" class="">
                                                              <v-icon>mdi-file-compare</v-icon>
                                                          </v-btn>
                                                      </div>
                                                  </td>
                                                  <template v-for="(vv, kk) in pageItemsNew[0]">
                                                      <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+ kk">
                                                          <span v-if="typeof v[kk] === 'number'">
                                                              {{ $nova.formatNumber(v[kk].toFixed(0)) }}
                                                          </span>
                                                          <span v-else>
                                                              {{isValidDate(v[kk])}}
                                                          </span>
                                                      </td>
                                                  </template>
                                              </tr>
                                          </tbody>
                                      </template>
                                  </v-simple-table>
                                  <div v-else class="text-center grey--text title pa-6"> No data available </div>
                              </div>
                          </v-col>
                      </v-row>
                  </div>
              </v-tab-item>
          </v-tabs-items>
      </div>
    </div>
    <div data-testid="transaction-matching-config-new__no-execution-state" v-else>
      <div data-testid="transaction-matching-config-new__no-data-state" v-if="statusCheck === TM_STATUS.NOT_STARTED">
        <div class="text-center grey--text title pa-6"> No data available (Transaction Matching)</div>
      </div>
      <div data-testid="transaction-matching-config-new__execution-failed-state" v-else-if="statusCheck === TM_STATUS.FAILED">
        <div class="text-center grey--text title pa-6"> No data available (Transaction Matching Execution Failed)</div>
      </div>
      <div data-testid="transaction-matching-config-new__execution-progress-state" v-else>
        <div class="text-center grey--text title pa-6"> No data available (Transaction Matching Execution In Progress)</div>
      </div>
    </div>
  </div>
</template>

<script>
import OnefileSummary from '../../OnefileSummary.vue'
import SummaryTable from '../../SummaryTable.vue'
import TMResultsDataTable from '../shared/TMResultsDataTable.vue'
import DownloadExcel from '../TransationMatching/downloadExcel.vue'
import { TM_STATUS, TM_RECONCILIATION } from '../../../../utils/constants.js';

export default {
    name: 'TransactionMatchingResults',
    components: {
        SummaryTable,
        OnefileSummary,
        TMResultsDataTable,
        DownloadExcel
    },
    props: {
        statusCheck: { type: [Number, String], default: '' },
        analysisDetails: { type: Object, default: () => ({}) },
        rundetails: { type: Object, default: () => ({}) },
        verificationlist: { type: Array, default: () => [] },
        selectedResultTab: { type: Number, default: 0 },
        annexurelist: { type: Array, default: () => [] },
        resultTab: { type: Number, default: 0 },
        resultTabItem: { type: Array, default: () => [] },
        ailoadingimage: { type: Boolean, default: false },
        stagefilterAI: { type: Array, default: () => [] },
        tabletype: { type: String, default: '' },
        loading: { type: Boolean, default: false },
        downloadExcelHistory: { type: Array, default: () => [] },
        loadingExcelHistory: { type: Boolean, default: false },
        executionbtnAI: { type: Boolean, default: false },
        table1twofileglobalInfo: { type: Object, default: () => ({}) },
        table1twoglobalList: { type: Array, default: () => [] },
        table1pagecounttwofile: { type: Number, default: 0 },
        table1twofile: { type: Number, default: 1 },
        table1collectiontwofile: { type: Object, default: () => ({}) },
        tableOneItemsTwoFile: { type: Array, default: () => [] },
        tableOneItemtwofileKeys: { type: Array, default: () => [] },
        stagetable1twofile: { type: Array, default: () => [] },
        table2twofileglobalInfo: { type: Object, default: () => ({}) },
        table2twoglobalList: { type: Array, default: () => [] },
        table2pagecounttwofile: { type: Number, default: 0 },
        table2twofile: { type: Number, default: 1 },
        table2collectiontwofile: { type: Object, default: () => ({}) },
        tableTwoItemsTwoFile: { type: Array, default: () => [] },
        tableTwoItemtwofileKeys: { type: Array, default: () => [] },
        stagetable2twofile: { type: Array, default: () => [] },
        GlobaleCollection: { type: [Object, String], default: () => ({}) },
        pagecount: { type: Number, default: 1 },
        page: { type: Number, default: 1 },
        pageItems: { type: Array, default: () => [] },
        pageItemsKeys: { type: Array, default: () => [] },
        stagefilter: { type: Array, default: () => [] },
        selectedcollection: { type: String, default: '' },
        comboAnnexer: { type: Array, default: () => [] },
        hasConsolidatedAnnexure: { type: Boolean, default: false },
        summeryCombo: { type: Array, default: () => [] },
        selectedSummeryFilter: { type: String, default: '' },
        annexercomboKeys: { type: Array, default: () => [] },
        filterCombo: { type: String, default: '' },
        filterArray: { type: Array, default: () => [] },
        selectcollection: { type: String, default: '' },
        selectkey: { type: [String, Number], default: '' },
        pagecountnew: { type: Number, default: 1 },
        pagenew: { type: Number, default: 1 },
        pageItemsNew: { type: Array, default: () => [] },
        table1globalInfo: { type: Object, default: () => ({}) },
        table1globalList: { type: Array, default: () => [] },
        table1pagecount: { type: Number, default: 1 },
        table1: { type: Number, default: 1 },
        tableOneItem: { type: Array, default: () => [] },
        tableOneItemKeys: { type: Array, default: () => [] },
        table1collection: { type: [Object, String], default: () => ({}) },
        stagefiltertable1: { type: Array, default: () => [] },
        table2globalInfo: { type: Object, default: () => ({}) },
        table2globalList: { type: Array, default: () => [] },
        table2pagecount: { type: Number, default: 1 },
        table2: { type: Number, default: 1 },
        tableTwoItem: { type: Array, default: () => [] },
        tableTwoItemKeys: { type: Array, default: () => [] },
        table2collection: { type: [Object, String], default: () => ({}) },
        stagefiltertable2: { type: Array, default: () => [] },
        stagefilterNew: { type: Array, default: () => [] },
        fileConfigInfo: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            TM_STATUS,
            TM_RECONCILIATION
        }
    },
    methods: {
        handleConsolidatedGenerate() {
            if (this.$refs.consolidatedResultsComponent) {
                const filtersAndSort = this.$refs.consolidatedResultsComponent.getFiltersAndSort();
                this.$emit('download-consolidated-excel', filtersAndSort);
            } else {
                this.$emit('generate-result', 'TMResults');
            }
        },
        handleCheckboxUpdate(propName, arr, val, isChecked) {
            let newArr = [...(arr || [])];
            if (isChecked) {
                if (!newArr.includes(val)) newArr.push(val);
            } else {
                newArr = newArr.filter(i => i !== val);
            }
            this.$emit(propName, newArr);
        },
        isValidDate(date) {
            if (date instanceof Date && !isNaN(date)) return date.toLocaleDateString();
            if (typeof date === 'string' && /^\d{1,4}[-/]\d{1,4}[-/]\d{1,4}/.test(date.trim())) {
                const parsed = new Date(date);
                if (!isNaN(parsed)) return parsed.toLocaleDateString();
            }
            return date;
        },
        // Pagination Emitters to keep template clean
        emitPaginationTable1TwoFile(page) {
            this.$emit('update:table1twofile', page);
            this.$emit('pagination-table1-two-file', this.table1collectiontwofile, page, 'Normal');
        },
        emitPaginationTable2TwoFile(page) {
            this.$emit('update:table2twofile', page);
            this.$emit('pagination-table2-two-file', this.table2collectiontwofile, page, 'Normal');
        },
        emitPaginationAI(page) {
            this.$emit('update:page', page);
            this.$emit('pagination-ai', this.GlobaleCollection, page);
        },
        emitPaginationSingle(page) {
            this.$emit('update:pagenew', page);
            this.$emit('pagination-single-api', this.GlobaleCollection, page);
        },
        emitPaginationTable1(page) {
            this.$emit('update:table1', page);
            this.$emit('pagination-table1', this.table1collection, page, 'Normal');
        },
        emitPaginationTable2(page) {
            this.$emit('update:table2', page);
            this.$emit('pagination-table2', this.table2collection, page, 'Normal');
        }
    }
}
</script>
